<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title">
                blog<span> Details</span>
              </h2>
            </div>
            <div class="col-md-6 col-sm-6 col-text-center">
              <nav
                aria-label="breadcrumb"
                class="blog-bradcrumb "
              >
                <ol class="breadcrumb bg-transparent mb-0">
                  <li class="breadcrumb-item">
                    <a href="/">
  Home
</a>

                  </li>
                  <li class="breadcrumb-item active">
                    <a href="#">
  Blog Details
</a>

                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->

      <!-- blog Section starts -->
      <section>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="#">
                        <img
                          src="../assets/images/blog/blog-details.jpg"
                          alt="blog"
                          class="img-fluid"
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>25 September 2019</h6>
                  <a href="#">
                    <h3 class="blog-head">New study shows importance of good tires
                    </h3>
                  </a>
                  <div class="blog-divider" />
                  <div class="blog-description">
                    <p>
                      Research released recently by the AAA in the US says driving on worn tires can seriously extend your stopping distance. This is a stark reminder to all of us to check our tires regularly so we can drive safely on the road.

                      The research, conducted by the AAA and the Automobile Club of Southern California’s Automotive Research Center was designed to quantify the difference between new tires and worn ones. We have known anecdotally for a long time that worn tires cannot possibly perform as well as new ones but now we have more specific evidence to prove it.

                      The findings were unsurprising. Tires worn down to 4/32 inch exhibited an average stopping distance of 87 feet on a car and 86 feet on a truck. They also found that worn tires all showed a 33 percent reduction in handling ability in passenger cars. The value tested, 4/32 inch is twice the legal limit in many US states and equates to 3.17mm. That is less than Canada’s legal limit which is 3.5mm or 5/32 inch.

                      "If tested side-by-side at 60 mph, vehicles with worn tires would still be traveling at an alarming 40 mph when reaching the same distance it takes for vehicles with new tires to make a complete stop," says Southern California AAA research centre manager Megan McKernan.
                    </p><p>
                      Regular tire checks can save your life
                      <br>
                      We have said it before and we will continue saying it, regular tire checks can and will save your life. Given the often adverse conditions Canadians have to contend with, having the right tire with the right tread depth is vital. Using winter tires in winter and summer tires in summer is only part of it.

                      Check your depth. Make sure all of your tires have at least 4mm of tread depth across the tire. If one side is more worn than the other, you may need to check balance. Don’t forget to check the spare too.

                      Rotate tires if necessary. Rotating tires can help maintain even wear across the vehicle depending on whether you have AWD, FWD or RWD. Not all tires can be rotated or are in a fit condition to be rotated. It is best to let a professional check for you.

                      Check tire condition. Look for splits, chunks of rubber missing, debris embedded into the tire and any damage to the tire. Remember to look on the inside as well as the side of the tire you can see.

                      Tire wear and condition is the one aspect of motoring nobody can afford to ignore. Have yours checked regularly to be completely safe. Car Nation Canada can perform tire checks as part of your regular service..
                    </p>
                    <h5>Mark jkcno</h5><h5 class="pull-right">
                      10 <i class="fa fa-heart-o" />, 50 <i class="fa fa-comments-o" />
                    </h5>
                  </div>
                </div>
              </div>
              <div class="blog-divider" />
              <div class="row">
                <div class="col-md-10 offset-md-1 leave-coment">
                  <h3 class="text-center">
                    Leave Your Comment
                  </h3>
                  <form class="theme-form footer-form p-0 mt-3">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-lg-6 col-md-12 md-fgrup-margin">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="your name"
                          >
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <input
                            id="exampleFormControlInput1"
                            type="email"
                            class="form-control"
                            placeholder="email address"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea
                        id="exampleFormControlTextarea1"
                        class="form-control"
                        rows="4"
                        placeholder="message"
                      />
                    </div>
                    <div class="form-button">
                      <button
                        type="submit"
                        class="btn btn-custom theme-color"
                      >
                        send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--blog Section End-->
      <!--Footer Section start-->
      <js />
      <!--Footer Section End-->
    </div>
    <!--blog Section end -->
  </div>
</template>
<script>
export default {
  name: 'BlogDetails2',
}
</script>



// WEBPACK FOOTER //
// src/blog/blog_details3.vue